module.exports = "https://www.gc-pro.gnp.com.mx/de85640486dcdfb8f85513ebca1cce10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/centro-atencion-gnp.svg
// module id = 959
// module chunks = 0